<template>
  <span>
    <Select v-model="dataId" value-key="name" placeholder="请选择工厂" filterable clearable>
      <Option v-for="item in factories" :key="item.id" :label="item.name" :value="item.id">
      </Option>
    </Select>
  </span>
</template>

<script>
import { ProduceFactory } from '@/services/resources'

export default {
  name: 'factory-picker',
  props: {
    value: null
  },
  data () {
    return {
      dataId: this.value,
      factories: []
    }
  },
  computed: {
  },
  beforeMount () {
    this.loadData()
  },
  methods: {
    loadData () {
      ProduceFactory.query().then((res) => {
        this.factories = res.data
      })
    }
  },
  watch: {
    dataId (val) {
      this.$emit('input', val)
      this.$emit('change', val)
    },
    value (val) {
      this.dataId = val
    },
    parentId (val) {
      this.loadData()
    }
  }
}
</script>

<style lang="scss">
</style>
